import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Beranda from "./pages/beranda/Beranda";
import Layanan from "./pages/layanan/Layanan";
import TentangKami from "./pages/tentang-kami/Tentangkami";
import Berita from "./pages/berita/Berita";
import Laporan from "./pages/laporan/Laporan";
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import NotFound from "./pages/not-found/NotFound";
import DetailBerita from "./pages/berita/DetailBerita";
import ScrollToTop from "./helper/ScrollToTop";
import Peraturan from "./pages/peraturan/Peraturan";

function App() {
  return (
    <Router>
      <div>
        <ScrollToTop/>
        <Navbar/>
        <Routes>
          <Route path="/" element={<Beranda />} />
          <Route path="/layanan" element={<Layanan />} />
          <Route path="/tentang-kami" element={<TentangKami />} />
          <Route path="/berita" element={<Berita />} />
          <Route path="/berita/:id" element={<DetailBerita />} />
          <Route path="/laporan" element={<Laporan />} />
          <Route path="/peraturan" element={<Peraturan />} />
           <Route path="*" element={<NotFound />} />
        </Routes>
        <Footer/>
      </div>
    </Router>
  );
}

export default App;
